import api from "./api";

export const getLossReasons = () => {
    return api.get("/loss-reasons");
};

export const createLossReason = (data) => {
    return api.post("/loss-reasons", data);
};

export const updateLossReason = (id, data) => {
    return api.put(`/loss-reasons/${id}`, data);
};

export const deleteLossReason = (id) => {
    return api.delete(`/loss-reasons/${id}`);
};
